<template>
  <!-- Doesn't work yet.  Not sure how to pass functions for cancel and delete via props -->
  <v-dialog
      v-model="show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{msg}}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(true)"
          >
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import myMixins from '../mixins/myMixins'

export default {
  props: ['msg'],
  data () {
    return {
      show: true
    }
  },
  mixins: [myMixins]
}
</script>
<style>
</style>
